import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1527203561188-dae1bc1a417f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxibGFjayUyMHdvbWFuJTIwc2tpbmNhcmUlMjBsdXh1cnl8ZW58MHx8fHwxNzgzMDI5NjQyfDA&ixlib=rb-4.1.0&q=85",
  mission: "https://images.unsplash.com/photo-1601326374180-e118ac4f7af4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwzfHxibGFjayUyMHdvbWFuJTIwbHV4dXJ5JTIwbGlmZXN0eWxlfGVufDB8fHx8MTc4MzAyOTY1NXww&ixlib=rb-4.1.0&q=85",
  hair: "https://images.unsplash.com/photo-1632765866070-3fadf25d3d5b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  skin: "https://images.pexels.com/photos/5938234/pexels-photo-5938234.jpeg?auto=compress&cs=tinysrgb&w=1200",
  beard: "https://images.unsplash.com/photo-1522529599102-193c0d76b5b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  accessories: "https://images.unsplash.com/photo-1622937320404-2297d57661d4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  selfcare: "https://images.pexels.com/photos/6621141/pexels-photo-6621141.jpeg?auto=compress&cs=tinysrgb&w=1200",
  products: "https://images.pexels.com/photos/4735936/pexels-photo-4735936.jpeg?auto=compress&cs=tinysrgb&w=1200",
  ig: [
    "https://images.unsplash.com/photo-1613876215075-276fd62c89a4?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    "https://images.unsplash.com/photo-1608979048467-6194dabc6a3d?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    "https://images.unsplash.com/photo-1598528738936-c50861cc75a9?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
    "https://images.unsplash.com/photo-1631730486572-226d1f595b68?crop=entropy&cs=srgb&fm=jpg&q=85&w=600",
  ],
};

export const CATEGORIES = [
  { key: "hair", label: "Hair Care", img: IMAGES.hair, blurb: "Nourishment for every crown." },
  { key: "skin", label: "Skin Care", img: IMAGES.skin, blurb: "Routines that reveal glow." },
  { key: "beard", label: "Beard Care", img: IMAGES.beard, blurb: "Refinement, well-groomed." },
  { key: "accessories", label: "Accessories", img: IMAGES.accessories, blurb: "The finishing touch." },
  { key: "selfcare", label: "Self-Care", img: IMAGES.selfcare, blurb: "Quiet luxury, daily." },
];

export const BOXES = [
  {
    name: "The Essentials Box",
    tag: "Hair Care Edition",
    desc: "A monthly routine of premium haircare selections from the finest Black-owned brands.",
    img: IMAGES.hair,
  },
  {
    name: "The King's Box",
    tag: "Men's Grooming & Self-Care",
    desc: "Curated grooming, beard care and self-care elevated for the modern gentleman.",
    img: IMAGES.beard,
  },
  {
    name: "The Crown Collection",
    tag: "Premium Mixed Experience",
    desc: "Our signature edition — a full spectrum of beauty, skin and self-care indulgence.",
    img: IMAGES.selfcare,
  },
];

export const FAQS = [
  { q: "What is Crowned Essence?", a: "Crowned Essence is a curated monthly subscription box celebrating exceptional Black-owned brands in haircare, skincare, beard care, and self-care. Every box is intentionally selected to deliver a premium, discovery-driven routine to your door." },
  { q: "How often do boxes ship?", a: "Once we launch, subscription boxes will ship monthly. Waitlist members receive first access and founding-member benefits." },
  { q: "Can I gift a subscription?", a: "Yes. Gifting will be available at launch — perfect for birthdays, self-care milestones, and celebrations of loved ones." },
  { q: "When do you launch?", a: "We are in pre-launch. Join the waitlist to be notified the moment doors open and to unlock early access pricing." },
  { q: "How can my brand be featured?", a: "We're actively partnering with Black-owned brands in haircare, skincare, beard care, and accessories. Submit an application on our Brand Partnerships page." },
];
